/**
 * Hourly haul billing (rentals-haul item 5, api#1054, 0512). Typed by hand from
 * lib/rental-haul.ts and surface-rentals.routes.ts at api 51b506f.
 *
 * The company switch `bill_haul_hourly` (rental_billing_defaults, default off)
 * decides whether any haul is billed: off, mob / demob fees only; on, every
 * completed dispatch that names a truck becomes a haul line, hours × the price
 * book's `haul_hourly` rate.
 */

/** GET /surface-rentals/settings/billing-rules — the fields this app reads. */
export interface RentalBillingRules {
  bill_haul_hourly?: boolean;
  [key: string]: unknown;
}

export type HaulRateSource = 'customer_truck' | 'customer_default' | 'company_truck' | 'company_default';

/**
 * One haul on the billing preview (`haul_lines`) and on a stored invoice's
 * `line_items` (where `amount` is always a number). A null `amount` means the
 * hours or the rate is missing — never $0 — and `missing_reason` names which.
 */
export interface RentalHaulLine {
  kind: 'haul';
  dispatch_id: string;
  dispatch_type: string;
  /** The tenant day the dispatch completed, YYYY-MM-DD. */
  haul_day: string;
  truck_id: string | null;
  truck_unit: string | null;
  haul_hours: number | null;
  haul_rate: number | null;
  haul_rate_source: HaulRateSource | null;
  price_book_id: string | null;
  amount: number | null;
  missing_reason: string | null;
  /** Order assets whose mob / demob fee also bills this trip: a flag, still billed. */
  mob_fee_overlap: { asset_id: string; asset_number?: string; fee?: string }[];
}

/** The price book rate type an hourly haul rate carries. */
export const HAUL_RATE_TYPE = 'haul_hourly';
